import * as Yup from 'yup';

import i18n from '@/i18n';

export const createEditClipValidation = () => {
  const schemaFields = {
    type: Yup.string().required(i18n.t('typeRequired', { ns: 'common' })),
    order: Yup.number()
      .required(i18n.t('orderRequired', { ns: 'common' }))
      .moreThan(0, i18n.t('orderMustGreatherThanZero', { ns: 'common' })),
    duration: Yup.number().when('assetType', {
      is: 'Image',
      then: Yup.number()
        .required(i18n.t('durationRequired', { ns: 'common' }))
        .moreThan(0, i18n.t('durationMustGreatherThanZero', { ns: 'common' })),
      otherwise: Yup.number().notRequired()
    })
  };

  return Yup.object().shape(schemaFields);
};
